/**
 * Check if shop functionality is disabled via environment variable
 * @returns {boolean} true if shop is disabled, false otherwise
 */
export const isShopDisabled = (): boolean => {
  return process.env.GATSBY_DISABLE_SHOP === "true"
}

